import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { BasicChip } from '@/components/Chips/BasicChip';

import { reviewDeletedItemStyles as sx } from './ReviewDeletedItem.styles';

type Props = {
	label: string;
	isIndividualCard?: boolean;
};

export const ReviewDeletedItem = ({ label, isIndividualCard }: Props) => {
	const { t } = useTranslation();
	const rootSx = isIndividualCard ? sx.individualCardRoot : sx.root;
	const labelSx = isIndividualCard ? sx.individuallabel : sx.label;

	return (
		<Box sx={rootSx}>
			{!isIndividualCard && <Box component={'span'} />}
			<Typography sx={labelSx}>{label}</Typography>
			<BasicChip label={t('Removed')} variant='removed' />
		</Box>
	);
};
